import "core-js/modules/es.array.push.js";
export default {
  name: "CaptchaPlus",
  mounted() {
    this.$emit("refresh");
  },
  props: {
    value: Boolean,
    width: {
      type: String,
      default: "300px"
    },
    calcPosType: {
      type: String,
      default: "dom",
      validator: value => ["dom", "screen"].includes(value)
    },
    maxDot: {
      type: Number,
      default: 5
      // validator: value => value > 10
    },
    imageBase64: String,
    thumbBase64: String
  },
  data() {
    return {
      dots: [],
      imageBase64Code: "",
      thumbBase64Code: ""
    };
  },
  watch: {
    value() {
      this.dots = [];
      this.imageBase64Code = "";
      this.thumbBase64Code = "";
    },
    imageBase64(val) {
      this.dots = [];
      this.imageBase64Code = val;
    },
    thumbBase64(val) {
      this.dots = [];
      this.thumbBase64Code = val;
    }
  },
  methods: {
    /**
     * @Description: 处理关闭事件
     */
    handleCloseEvent() {
      this.$emit("close");
      // this.dots = []
      // this.imageBase64Code = ''
      // this.thumbBase64Code = ''
    },
    /**
     * @Description: 处理刷新事件
     */
    handleRefreshEvent() {
      this.dots = [];
      this.$emit("refresh");
    },
    /**
     * @Description: 处理确认事件
     */
    handleConfirmEvent() {
      this.$emit("confirm", this.dots);
    },
    /**
     * @Description: 处理dot
     * @param ev
     */
    handleClickPos(ev) {
      if (this.dots.length >= this.maxDot) {
        return;
      }
      const e = ev || window.event;
      e.preventDefault();
      const dom = e.currentTarget;
      const {
        domX,
        domY
      } = this.getDomXY(dom);
      // ===============================================
      // @notice 如 getDomXY 不准确可尝试使用 calcLocationLeft 或 calcLocationTop
      // const domX = this.calcLocationLeft(dom)
      // const domY = this.calcLocationTop(dom)
      // ===============================================
      let mouseX = navigator.vendor === "Netscape" ? e.pageX : e.x + document.body.offsetTop;
      let mouseY = navigator.vendor === "Netscape" ? e.pageY : e.y + document.body.offsetTop;
      // 兼容移动触摸事件
      if (e.touches && e.touches.length > 0) {
        mouseX = e.touches[0].clientX;
        mouseY = e.touches[0].clientY;
      } else {
        mouseX = e.clientX;
        mouseY = e.clientY;
      }

      // 计算点击的相对位置
      const xPos = mouseX - domX;
      const yPos = mouseY - domY;

      // 转整形
      const xp = parseInt(xPos.toString());
      const yp = parseInt(yPos.toString());

      // 减去点的一半
      this.dots.push({
        x: xp - 11,
        y: yp - 11,
        index: this.dots.length + 1
      });
      return false;
    },
    /**
     * @Description: 找到元素的屏幕位置
     * @param el
     */
    calcLocationLeft(el) {
      let tmp = el.offsetLeft;
      let val = el.offsetParent;
      while (val != null) {
        tmp += val.offsetLeft;
        val = val.offsetParent;
      }
      return tmp;
    },
    /**
     * @Description: 找到元素的屏幕位置
     * @param el
     */
    calcLocationTop(el) {
      let tmp = el.offsetTop;
      let val = el.offsetParent;
      while (val != null) {
        tmp += val.offsetTop;
        val = val.offsetParent;
      }
      return tmp;
    },
    /**
     * @Description: 找到元素的屏幕位置
     * @param dom
     */
    getDomXY(dom) {
      let x = 0;
      let y = 0;
      if (dom.getBoundingClientRect) {
        let box = dom.getBoundingClientRect();
        let D = document.documentElement;
        x = box.left + Math.max(D.scrollLeft, document.body.scrollLeft) - D.clientLeft;
        y = box.top + Math.max(D.scrollTop, document.body.scrollTop) - D.clientTop;
      } else {
        while (dom !== document.body) {
          x += dom.offsetLeft;
          y += dom.offsetTop;
          dom = dom.offsetParent;
        }
      }
      return {
        domX: x,
        domY: y
      };
    }
  }
};